import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { DoctorBreadcrumbService } from '../breadcrumb.service';
import { STORAGE_ASSETS_LINK } from 'src/app/constant/constant';
import { yt_video } from './.././../../../models/video';
import { JsonDataService } from 'src/app/services/json-data.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
    selector: 'app-doctorvideosection',
    templateUrl: './doctorvideosection.component.html',
    styleUrls: ['./doctorvideosection.component.css']
})
export class DoctorvideosectionComponent implements OnInit {
    base_url: string = '';
    doctorvideos: yt_video[] = [];
    slug: string = "";
    constructor(
        private readonly router: Router,
        private readonly utilitiesService: UtilitiesService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly jsonDataService: JsonDataService,
        private readonly providerstateService: ProviderStateService
    ) {
        this.base_url = this.utilitiesService.getBaseUserURL(
            this.router.url,
            2
        );
        
    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`]},
            { label: 'Videos' }
        ]);
        await this.getDoctorVideoData();
    }
    async getDoctorVideoData() {
        await this.jsonDataService
            .getDoctorVideoData()
            .then((result) => {
                if (result.success) {
                    result.data.forEach((ele) => {
                        ele.imgsrc = STORAGE_ASSETS_LINK + ele.imgsrc;
                    });
                    this.doctorvideos = result.data;
                }
            });
    }
}
